import { render } from "./ClientsCreate.vue?vue&type=template&id=55bd76cc"
import script from "./ClientsCreate.vue?vue&type=script&lang=js"
export * from "./ClientsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__